import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  ApplicationVersionsData,
  ApplicationVersionData,
} from "app/shared";
import { OsTypeConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";

@Component({
  selector: "os-type-counts-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class OsTypeCountsChartComponent
  extends BaseChartLogic<OsTypeConfig, ApplicationVersionsData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      OsTypeConfig,
      _ngZone
    );
    this.handleDataSubscription(this.analyticsService.osTypeDataChange);
  }

  dataPointKey: string = "Total";
  getDataPointDisplayValue(dataPoint: ApplicationVersionData): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    //this.addOsTypeToFilterSettings(); //DO NOT ADD OS TYPE TO FILTER SETTINGS
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
  }

  refreshData(): void {
    this.analyticsService.getOsTypeData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
